import { create } from 'zustand';
import { ticketsApi } from '@/shared/api/tickets';

interface PendingApprovalsState {
  pending: number;
  refresh: () => Promise<void>;
  reset: () => void;
}

export const usePendingApprovalsStore = create<PendingApprovalsState>((set) => ({
  pending: 0,
  refresh: async () => {
    try {
      const res = await ticketsApi.myPendingApprovals();
      set({ pending: res.data?.pending ?? 0 });
    } catch {
    }
  },
  reset: () => set({ pending: 0 }),
}));
